import client from './api-client';

export const getConfiguracionForm41 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form41: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getDatosGestion = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboAmbitoGestion = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboAmbitoGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getComboInstanciaGestion = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboInstanciaGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboModoContacto = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboModoContacto: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboRespuestaContacto = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboRespuestaContacto: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosContactoTercero = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado/contacto?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosContactoTercero: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const enviarRecepcion = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/contacto', file);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaRecepcion: response.data};
        } else {
            return {respuestaRecepcion: response.data};
        }

    } catch(error){
        throw error;
    }
}

export const desistirAsiganacion = async(query) => {
    try {
        
        const response = await client.desistirAsig('getion-implicado/desisitir-asignacion', query);
        
        if (response.status === 200 && response.data.code === 1) {
            return response.data;
        } else {
            return response.data;
        }

    } catch(error){
        throw error;
    }
}